import useResponsive from "./useResponsive";

export const useIsMobile = () => {
  return useResponsive("down", "sm");
};
